<!-- <section *ngIf="isEditMode">
<div class="table-content" *ngIf="type == 'string'" title="{{cellValue}}">
  <input class="form-control" [(ngModel)]="cellValue" (blur)="blurAction()" autofocus>
</div>
<div class="table-content" *ngIf="type == 'number'" title="{{cellValue}}">
  <input class="form-control" [(ngModel)]="cellValue" (blur)="blurAction()" autofocus>
</div>

<div class="table-content" *ngIf="type == 'img'" title="{{cellValue}}">
  <img [src]="cellValue" class="img-section">
</div>
<div class="table-content" *ngIf="type == 'ratting'" title="{{cellValue}}">
  <input class="form-control" [(ngModel)]="cellValue" type="number" max="1" maxlength='1' (blur)="blurRattingAction()" autofocus>
</div>
<div class="table-content" *ngIf="type == 'currency'" title="{{cellValue}}">
  <input class="form-control" [(ngModel)]="cellValue" (blur)="blurAction()"> -->

  <!--<input autocomplete="off" type="text" class="form-control fn-input" [(ngModel)]="cellValue" fnCurrencyDirective maxLength="10" (blur)="blurAction()" autofocus />


</div>
<div class="table-content" *ngIf="type == 'boolean'" title="{{cellValue}}">

  <fn-switch [(ngModel)]="cellValue" [name]="'type'"> </fn-switch>
</div>
<div class="table-content" *ngIf="type == 'email'" title="{{cellValue}}">
  <input class="form-control" [(ngModel)]="cellValue" (blur)="blurAction()">
</div>
<div class="table-content" *ngIf="type == 'lookup'" title="{{cellValue}}">
  <select [(ngModel)]="cellValue" (change)="blurAction()" class="form-control table-select">
    <option *ngFor="let lookupItem of lookupArray" [value]="lookupItem.id">{{lookupItem.value}}</option>
  </select>
</div>
<div class="table-content" *ngIf="type == 'phone'" title="{{cellValue}}">
  <input class="form-control" [(ngModel)]="cellValue" (blur)="blurAction()" autofocus>
</div>

<div class="table-content" *ngIf="type == 'color'" class="color-test padding-10 choppOff" [ngStyle]="{'background-color': cellValue}">
</div>


</section> -->

<section>
  @if (isLoadCustomComp) {
    <div class="table-content">
      <ng-template #componentRender></ng-template>
    </div>
  } @else {
    @switch (column.componentTypeID) {
      @default {
        {{ cellValue }}
      }
      @case ('TEXT') {
        <fn-grid-text [cellValue]="cellValue" [column]="column" (cellBlur)="cellBlur.emit($event)" (cellFocus)="cellFocus.emit($event)" (cellValueChange)="cellValueChange.emit($event)"
        (cellClick)="cellClick.emit($event)"></fn-grid-text>
      }
      @case ('BOOLEAN') {
        <fn-grid-boolean [cellValue]="cellValue" [column]="column" (cellValueChange)="cellValueChange.emit($event)">
        </fn-grid-boolean>
      }
      @case ('NUMBER') {
        <fn-grid-number [cellValue]="cellValue" [column]="column" (cellValueChange)="cellValueChange.emit($event)">
        </fn-grid-number>
      }
      @case ('LOOKUP') {
        <fn-grid-lookup class="fn-grid-lookup" [cellValue]="cellValue" [column]="column" (selectionChange)="selectionChange.emit($event)" [row]="row">
        </fn-grid-lookup>
      }
      @case ('COLOR') {
        <fn-grid-color [cellValue]="cellValue"></fn-grid-color>
      }
      @case ('IMAGE') {
        <img [src]="cellValue" class="img-section" />
      }
      @case ('CURRENCY') {
        <input autocomplete="off" type="text" class="form-control fn-input" [(ngModel)]="cellValue" fnCurrencyDirective maxLength="10" disabled="disabled" />
      }
      @case ('RATTING') {
        @for (index of rattingArray; track index) {
          <i class="fn-global-star-fill black"></i>
        }
      }
    }
  }
</section>